import { render, staticRenderFns } from "./CrearProfesional.vue?vue&type=template&id=16fef19f&scoped=true&"
import script from "./CrearProfesional.vue?vue&type=script&lang=js&"
export * from "./CrearProfesional.vue?vue&type=script&lang=js&"
import style0 from "./CrearProfesional.vue?vue&type=style&index=0&id=16fef19f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16fef19f",
  null
  
)

export default component.exports